import React, { Component } from "react";
import { connect } from "react-redux";
import { DefaultConstructionComponentAction } from "../../../actions";
import { CheckBox } from "../../../components/checkbox";
import { Panel } from "../../../components/panel";
import Button from "../../../components/button";
import { Confirm } from "../../../components/confirm";
import { BoxLoading } from "../../../components/loading";
import { Modal, Title, ScrollBox, ActionBox, Description } from "./style";

class DefaultComponentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = { ids: [], query: "", emptyError: false, fetched: false };

    this.onSelect = this.onSelect.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    let result = { ...state };
    if (!state.fetched && props.list.length > 0) {
      result.fetched = true;
      result.ids = props.list && props.list.map(item => item.id);
    }
    return result;
  }

  componentDidMount() {
    this.props.getList();
  }

  onSelect(item) {
    const { ids } = this.state;
    if (ids.indexOf(item.id) !== -1) {
      this.setState({ ids: ids.filter(id => id !== item.id) });
    } else {
      this.setState({ ids: [...ids, item.id] });
    }
  }

  onSubmit(item) {
    const { ids } = this.state;

    if (ids.length > 0) {
      this.props.store(ids);
    } else {
      this.setState({ emptyError: true });
    }
  }

  render() {
    const { ids, query, emptyError } = this.state;
    const { list, loading, storeStatus } = this.props;
    const filteredList = list.filter(item => item.name.indexOf(query) !== -1);

    return (
      <Modal
        show={this.props.show && !storeStatus}
        onClick={() => this.props.onClose()}
      >
        <Panel
          directionCol
          style={{ backgroundColor: "white", width: "460px" }}
          onClick={e => e.stopPropagation()}
        >
          <Title>منابع مصرفی مورد نیاز خود را انتخاب نمایید</Title>
          <Description>
            لیست زیر بصورت پیشنهادی و عموما مرتبط با صنعت ساختمان می باشد و ممکن
            است تمام و یا مواردی از آن با نوع پروژه شما هم‌خوانی نداشته باشد.
          </Description>
          {loading && list.length === 0 ? (
            <BoxLoading />
          ) : (
            <ScrollBox>
              {filteredList.length > 0 ? (
                filteredList.map(item => (
                  <CheckBox
                    key={item.id}
                    label={item.name}
                    checked={ids.indexOf(item.id) !== -1}
                    onSelect={() => this.onSelect(item)}
                  />
                ))
              ) : (
                <p>موردی یافت نشد</p>
              )}
            </ScrollBox>
          )}
          <ActionBox>
            <Button
              btn="primary"
              onClick={e => {
                e.preventDefault();
                this.onSubmit();
              }}
              loading={loading}
            >
              تایید
            </Button>
            <Button
              btn="ghost"
              onClick={e => {
                e.preventDefault();
                this.props.onClose();
              }}
              disabled={loading}
            >
              انصراف
            </Button>
          </ActionBox>
        </Panel>
        <Confirm
          show={emptyError}
          content={{
            type: "danger",
            icon: "icon mapsa-notification",
            message: "هیچ‌ کدام از موارد انتخاب نشده است.",
            acceptButtonText: "باشه"
          }}
          acceptHandler={() => {
            this.setState({ emptyError: false });
          }}
          close={() => this.setState({ emptyError: false })}
        />
      </Modal>
    );
  }
}

const mapStateToProps = store => {
  return {
    list: store.DefaultConstructionComponent.data,
    loading: store.DefaultConstructionComponent.loading,
    storeStatus: store.DefaultConstructionComponent.storeStatus
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getList: () => {
      dispatch(DefaultConstructionComponentAction.getListRequest());
    },
    store: components => {
      dispatch(DefaultConstructionComponentAction.storeRequest(components));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultComponentComponent);
